import { IHeadLabel, ISort } from "../types/table";

const defaultFilters = {
    code: '',
    name: ''
};

const branchOrderOptions: ISort[] = [
    {
        label: "Nome Crescente",
        direction: "asc",
        sortBy: "Name"
    },
    {
        label: "Nome Decrescente",
        direction: "desc",
        sortBy: "Name"
    },
    {
        label: "Código Crescente",
        direction: "asc",
        sortBy: "Code"
    },
    {
        label: "Código Decrescente",
        direction: "desc",
        sortBy: "Code"
    },
    {
        label: "Cadastro Crescente",
        direction: 'asc',
        sortBy: 'Id'
    },
    {
        label: "Cadastro Decrescente",
        direction: 'desc',
        sortBy: 'Id'
    }
];

const columnsTable: IHeadLabel[] = [
    {
        label: "ID",
    },
    {
        label: "Código"
    },
    {
        label: "Nome"
    },
    {
        label: "Ativo"
    },
    {
        label: "",
        align: "right"
    }
];


export {
    defaultFilters,
    branchOrderOptions,
    columnsTable
}